import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {ModeleTypeAction, modeleTypesActionsInitValues} from '../../../components/Models'
import {editTypesActions, getOneTypesActions} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import {TypesActionsForm} from './components/TypesActionsForm'
import Swal from 'sweetalert2'

const TypesActionsEditPage = () => {
  const navigate = useNavigate()
  let {typeId} = useParams()
  const [data, setData] = useState<ModeleTypeAction>(modeleTypesActionsInitValues)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getTypesActionsData()
  }, [typeId])

  const getTypesActionsData = () => {
    getOneTypesActions(typeId)
      .then((typeRequest) => {
        if (typeRequest?.status === 200) {
          if (typeRequest?.data?.id !== undefined && typeRequest?.data?.id !== null) {
            const updatedData = Object.assign({...data}, typeRequest?.data)
            setData({...updatedData})
          }
          setLoading(false)
        } else {
          navigate(`/types-actions`)
        }
      })
      .catch((e) => {
        setLoading(false)
        navigate(`/types-actions`)
      })
  }

  const submitForm = async (fieldsToUpdate: Partial<ModeleTypeAction>, callback): Promise<void> => {
    const updatedData = Object.assign({...data}, fieldsToUpdate)
    var requestOk = false
    try {
      const typeActionsRequest = await editTypesActions(typeId, updatedData)
      if (typeActionsRequest?.status === 200) {
        requestOk = true
      }
    } catch (ex: any) {
      if (ex.response?.status === 400) {
        const errorMessage =
          ex.response?.data?.message || 'Ce type action avec ce code existe déjà.'
        Swal.fire({
          title: 'Oups',
          text: errorMessage,
          icon: 'warning',
          confirmButtonText: 'OK',
          confirmButtonColor: '#1BC5BD',
        })
      } else {
        console.error(ex)
      }
    } finally {
      callback()
      if (requestOk) {
        setData({...updatedData})
        navigate(`/types-actions`)
      }
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Modifier un type action</h3>
          </div>
        </div>

        <div>
          {loading ? (
            <LoadingData />
          ) : (
            <TypesActionsForm motifId={typeId} data={data} submitForm={submitForm} />
          )}
        </div>
      </div>
    </>
  )
}

export default TypesActionsEditPage
